import { SafetyPlanTestID } from "@/constants/TestID";
import SafetyPlanSection, {
  BulletPointText,
  LinkText,
} from "@/ui/components/profile/safetyPlan/SafetyPlanSection";
import { HStack } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

interface RiskOfSelfHarmSectionProps {
  onLinkPress: (text: string) => void;
}

const EmergencyNumber = "911";

const RiskOfSelfHarmSection = ({ onLinkPress }: RiskOfSelfHarmSectionProps) => {
  const riskOfSelfHarm = [
    <HStack key={SafetyPlanTestID.RiskOfSelfHarm}>
      <BulletPointText
        testID={joinTestIDs(SafetyPlanTestID.RiskOfSelfHarm, "call")}
        text="Call "
      />
      <LinkText
        linkType="tel"
        onPress={() => {
          onLinkPress(EmergencyNumber);
        }}
        testID={joinTestIDs(SafetyPlanTestID.RiskOfSelfHarm, EmergencyNumber)}
        text={EmergencyNumber}
      />
    </HStack>,
    <BulletPointText
      key={joinTestIDs(SafetyPlanTestID.RiskOfSelfHarm, "nearest-er")}
      testID={joinTestIDs(SafetyPlanTestID.RiskOfSelfHarm, "nearest-er")}
      text="Go to the nearest emergency room"
    />,
  ];

  return (
    <SafetyPlanSection
      shouldPrefixWithBullet
      statements={riskOfSelfHarm}
      testID={SafetyPlanTestID.RiskOfSelfHarm}
      title="If you are at risk of hurting yourself:"
    />
  );
};

export default RiskOfSelfHarmSection;
